export default {
  NOT_FILLED: 1,
  FILLED: 2,
  ALL: 3,
};
